import { useContext } from "react";
import {
  PersonFiltersContext,
  PersonFiltersEventContext,
} from "../../../../context/FiltersContext";
import {
  IPersonInteresseFilterSetting,
  QueryFilter,
  PersonFilterKeys,
} from "../../../../interfaces/filters";
import { AccordionFilterItem } from "../../../accordion/Accordion";
import AppliedFilterItem from "../../../filter/AppliedFilterItem";
import { PersonDtoFilterInput } from "../../../../interfaces/schema";
import { f } from "../../../../util/f";
import AutoCompleteInteresse from "../../../autocomplete/AutoCompleteInteresse";

// helpers
const filterKey: QueryFilter<PersonFilterKeys>["filterKey"] = "personInteresse";

export default function PersonInteresseFilter() {
  // context
  const filters = useContext(PersonFiltersContext);
  const updateFilters = useContext(PersonFiltersEventContext);

  // // find active settings
  const settings: IPersonInteresseFilterSetting[] =
    filters.find((f) => f.filterKey === filterKey)?.settings || [];

  // handlers
  function updateFilterHandler(selectedItem: IInteresse) {
    // check if selected element already is in settings otherwise add it
    if (!settings?.some((s) => s.id === selectedItem.id)) {
      settings.push({ id: selectedItem.id, name: selectedItem.navn });
    }

    const filterString = f<PersonDtoFilterInput>()
      .addFilter("personInteresse", {
        some: {
          or: settings.map((set) => {
            return {
              interesseId: {
                eq: set.id,
              },
            };
          }),
        },
      })
      .build();

    const queryFilter: QueryFilter<
      PersonFilterKeys,
      IPersonInteresseFilterSetting[]
    > = {
      filter: filterString,
      filterKey: filterKey,
      settings: settings,
      parentFilter: "and",
    };

    updateFilters({
      event: "update",
      queryFilter: queryFilter,
    });
  }

  function removeFilterHandler(id: IPersonInteresseFilterSetting["id"]) {
    const updatedSettings: IPersonInteresseFilterSetting[] =
      settings.filter((set: IPersonInteresseFilterSetting) => {
        return id !== set.id;
      }) || [];

    const filterString = f<PersonDtoFilterInput>()
      .addFilter("personInteresse", {
        some: {
          or: settings.map((set) => {
            return {
              interesseId: {
                eq: set.id,
              },
            };
          }),
        },
      })
      .build();

    const update = updatedSettings.length > 0;

    if (update) {
      updateFilters({
        event: "update",
        queryFilter: {
          filterKey: filterKey,
          filter: filterString,
          settings: updatedSettings,
        },
      });
    } else {
      updateFilters({
        event: "delete",
        queryFilter: {
          filterKey: filterKey,
        },
      });
    }
  }

  return (
    <AccordionFilterItem
      title="Interesse"
      value="interesse"
      isActive={filters.some((f) => f.filterKey === filterKey)}
    >
      {settings && (
        <div className="c-applied-filter-group">
          {settings?.map((filter) => (
            <AppliedFilterItem
              key={filter.id}
              label={filter.name}
              removeFilterHandler={() => removeFilterHandler(filter.id)}
            />
          ))}
        </div>
      )}

      <AutoCompleteInteresse
        clearAfterSelection
        placeholder="Vælg interesse ..."
        onSelectedItemChange={(event) => {
          if (event.selectedItem) {
            updateFilterHandler(event.selectedItem);
          }
        }}
      />
    </AccordionFilterItem>
  );
}
